// /src/Components/common/ErrorBoundary.jsx
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // log if you want
    console.error(error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="p-6">
          <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-lg">
            <div className="font-semibold mb-1">Something went wrong</div>
            <pre className="whitespace-pre-wrap text-xs">
              {String(this.state.error.message || this.state.error)}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
